// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-bar-chart {
  display: flex;
  align-items: end;
  justify-content: center;
}

@media (min-width: 1024px) {
  .header-bar-chart {
    width: 116px;
  }
}
@media (min-width: 1366px) {
  .header-bar-chart {
    width: 148px;
  }
}
@media (min-width: 1920px) {
  .header-bar-chart {
    width: 180px;
  }
}`, "",{"version":3,"sources":["webpack://./../job/src/components/TimelineHeader/TimelineHeader.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE;IACE,YAAA;EACF;AACF;AAEA;EACE;IACE,YAAA;EAAF;AACF;AAGA;EACE;IACE,YAAA;EADF;AACF","sourcesContent":[".header-bar-chart {\n  display: flex;\n  align-items: end;\n  justify-content: center;\n}\n\n@media (min-width: 1024px) {\n  .header-bar-chart {\n    width: 116px;\n  }\n}\n\n@media (min-width: 1366px) {\n  .header-bar-chart {\n    width: 148px;\n  }\n}\n\n@media (min-width: 1920px) {\n  .header-bar-chart {\n    width: 180px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
